// ============================================================================
// CANCUN100 — menuApp.js  (APP 2/09 · F8: íconos y grupos del menú, para «A · Arriba» y «B · Lateral»)
// ----------------------------------------------------------------------------
// Las pestañas y permisos siguen saliendo de navItems en App.js (no cambian): aquí solo se les pone ícono y grupo.
// Íconos SVG propios (trazo 1.7, estilo lucide), sin dependencias. Grupos: Ventas · Dinero · Equipo · Referencia ·
// Sistema · Mi cuenta (los agentes ven Ventas · Dinero · Referencia · Mi cuenta, como en el prototipo).
// ============================================================================
import React from 'react';

const P = {
  nueva:       <path d="M12 5v14M5 12h14" />,
  cot:         <><path d="M7 3h7l5 5v13H7z" /><path d="M14 3v5h5" /></>,
  ventas:      <><path d="M3 3v18h18" /><path d="m7 15 4-4 3 3 5-6" /></>,
  bolsa:       <><path d="M6 7h12l-1 13H7z" /><path d="M9 7a3 3 0 0 1 6 0" /></>,
  precios:     <><path d="M20 12 12 20 4 12V4h8z" /><circle cx="8.5" cy="8.5" r="1.5" /></>,
  horarios:    <><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M3 10h18M8 3v4M16 3v4" /></>,
  panel:       <><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></>,
  resumen:     <><rect x="3" y="3" width="7" height="9" rx="1" /><rect x="14" y="3" width="7" height="5" rx="1" /><rect x="14" y="12" width="7" height="9" rx="1" /><rect x="3" y="16" width="7" height="5" rx="1" /></>,
  finanzas:    <><circle cx="12" cy="12" r="9" /><path d="M12 7v10M9.5 9.5c0-1 1-1.5 2.5-1.5s2.5.5 2.5 1.5-1 1.5-2.5 2-2.5 1-2.5 2 1 1.5 2.5 1.5 2.5-.5 2.5-1.5" /></>,
  vendedores:  <><circle cx="9" cy="8" r="3.5" /><path d="M2.5 20a6.5 6.5 0 0 1 13 0" /><circle cx="17" cy="9" r="2.5" /><path d="M16 15.5a5 5 0 0 1 5.5 4.5" /></>,
  folios:      <><path d="M4 4h12l4 4v12H4z" /><path d="M8 12h8M8 16h5" /></>,
  pagar:       <><rect x="3" y="6" width="18" height="12" rx="2" /><path d="M3 10h18M7 15h3" /></>,
  hoteles:     <><path d="M3 21V9l9-6 9 6v12" /><path d="M9 21v-6h6v6M3 21h18" /></>,
  proveedores: <><path d="M3 7h11v10H3zM14 11h4l3 3v3h-7z" /><circle cx="7" cy="18.5" r="1.5" /><circle cx="17" cy="18.5" r="1.5" /></>,
  ajustes:     <><path d="M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12" /><circle cx="16" cy="6" r="2" /><circle cx="10" cy="12" r="2" /><circle cx="18" cy="18" r="2" /></>,
  agentes:     <><circle cx="8" cy="8" r="3.5" /><circle cx="16.5" cy="9.5" r="2.5" /><path d="M2 20a6 6 0 0 1 12 0M14 19.5a4.5 4.5 0 0 1 8 0" /></>,
  auditoria:   <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
  cambiar:     <><path d="M9 3v7l-5 8a2 2 0 0 0 1.7 3h12.6a2 2 0 0 0 1.7-3l-5-8V3" /><path d="M8 3h8" /></>,
  balance:     <><rect x="2" y="6" width="20" height="13" rx="2" /><path d="M2 10h20M6 15h4" /></>,
  comisiones:  <><path d="M12 3v18M7 8h7a3 3 0 0 1 0 6H8" /></>,
  cambio:      <><path d="M4 8h13l-3-3M20 16H7l3 3" /></>,
  menu:        <path d="M4 6h16M4 12h16M4 18h16" />,
  chevrons:    <path d="m11 17-5-5 5-5M18 17l-5-5 5-5" />,
  cerrar:      <path d="M6 6l12 12M18 6 6 18" />,
  salir:       <><path d="M15 4h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3" /><path d="M10 17l-5-5 5-5M5 12h11" /></>,
  actualizar:  <><path d="M20 12a8 8 0 1 1-2.3-5.7" /><path d="M20 4v5h-5" /></>,
};

export function IconoMenu({ name, size = 18 }) {
  const d = P[name];
  if (!d) return null;
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flex: 'none' }}>{d}</svg>
  );
}

// Pestaña (clave de navItems) → ícono
export const ICONO_DE = {
  'nueva-reserva': 'nueva', 'nueva-reserva-admin': 'nueva', 'mis-ventas': 'ventas', 'mi-bolsa': 'bolsa', 'mis-cotizaciones': 'cot',
  'mis-comisiones-tt': 'comisiones', horarios: 'horarios', 'lista-precios': 'precios', 'mi-panel': 'panel',
  'balance-real': 'balance', 'resumen-global': 'resumen', resumen: 'resumen', finanzas: 'finanzas', 'panel-vendedores': 'vendedores',
  'control-folios': 'folios', 'pagar-comisiones': 'pagar', 'pago-hoteles': 'hoteles', proveedores: 'proveedores', ajustes: 'ajustes',
  'agentes-tt': 'agentes', agenda: 'horarios', llegadas: 'hoteles', auditoria: 'auditoria', 'cambiar-panel': 'cambiar', 'ir-agente': 'cambio', 'volver-admin': 'cambio',
};

// Grupos del menú lateral (orden fijo). Una pestaña que no esté aquí cae en «Más».
const GRUPOS = [
  ['Ventas', ['nueva-reserva', 'nueva-reserva-admin', 'mis-ventas', 'control-folios']], // APP 2/19: cotizaciones dentro de Mis ventas
  ['Dinero', ['mi-bolsa', 'mis-comisiones-tt', 'resumen-global', 'resumen', 'balance-real', 'finanzas', 'pagar-comisiones', 'pago-hoteles', 'proveedores', 'ajustes']],
  ['Equipo', ['panel-vendedores', 'agentes-tt', 'llegadas']],
  ['Referencia', ['lista-precios', 'horarios']], // APP 2/19: la agenda vive dentro de Horarios
  ['Sistema', ['auditoria', 'cambiar-panel']],
  ['Mi cuenta', ['mi-panel', 'ir-agente', 'volver-admin']],
];

// Quita el emoji / signo del principio de la etiqueta (el ícono SVG lo reemplaza). «+ Reserva» → «Nueva reserva».
export const limpiarEtiqueta = (l) => {
  const s = String(l || '').trim();
  if (/^\+ ?Reserva/i.test(s)) return s.replace(/^\+ ?Reserva/i, 'Nueva reserva');
  return s.replace(/^[^\p{L}\p{N}]+\s*/u, '');
};

// navItems ([clave, etiqueta]) → [{ grupo, items: [{ key, label, icon }] }], respetando el orden y los permisos de navItems.
export const seccionesDe = (navItems) => {
  const items = (navItems || []).map(([k, l]) => ({ key: k, label: limpiarEtiqueta(l), icon: ICONO_DE[k] || 'folios' }));
  const usados = new Set();
  const out = GRUPOS.map(([grupo, claves]) => {
    const its = items.filter((it) => claves.includes(it.key));
    its.forEach((it) => usados.add(it.key));
    return { grupo, items: its };
  }).filter((g) => g.items.length);
  const resto = items.filter((it) => !usados.has(it.key));
  if (resto.length) out.push({ grupo: 'Más', items: resto });
  return out;
};

export const MENUS = ['arriba', 'lateral'];
export const MENU_DEFAULT = 'arriba';
export const etiquetaMenu = (m) => (m === 'lateral' ? 'Lateral' : 'Arriba');
export const migrarMenu = (v) => (MENUS.includes(v) ? v : MENU_DEFAULT);
